export class TblINI {
  id?: number;
  userId: string;
  compresseddata: string;
  fileid: string;
  size: string;
  modified: any;
  created: any;
}
